export type TestMatchRow = Record<string, unknown>;

export type CheckTestMatchesGetResponse = {
  ok?: boolean;
  status?: number;
  jsonData?: { matches?: TestMatchRow[] | null } | null;
};

export type CheckTestMatchesResult =
  | { status: "found"; matches: TestMatchRow[]; toast: "success"; message: string }
  | { status: "none"; toast: "info"; message: string }
  | { status: "error"; toast: "error"; message: string };

const NONE_MESSAGE = "No duplicate tests found for this user.";

export async function checkTestMatchesAsync(
  testId: number | string | null | undefined,
  getAsync: (url: string) => Promise<CheckTestMatchesGetResponse>
): Promise<CheckTestMatchesResult | null> {
  if (!testId) return null;
  try {
    const resp = await getAsync(`/Test/${testId}/Matches`);
    if (resp?.ok) {
      const matches = Array.isArray(resp.jsonData?.matches) ? resp.jsonData.matches : [];
      if (matches.length > 0) {
        return {
          status: "found",
          matches,
          toast: "success",
          message: `Found ${matches.length} duplicate tests. Reloading data...`,
        };
      }
      return { status: "none", toast: "info", message: NONE_MESSAGE };
    }
    if (resp?.status === 204) {
      return { status: "none", toast: "info", message: NONE_MESSAGE };
    }
    return { status: "error", toast: "error", message: "Failed to check for duplicate tests" };
  } catch {
    return { status: "error", toast: "error", message: "Error checking for duplicate tests" };
  }
}
